import { countryCodes } from './constants.js';

export const DEFAULT_COUNTRY_CODE = '91';

const COUNTRY_CODES = countryCodes.reduce((acc, country) => {
  acc[country.value] = country.value.replace('+', '');
  return acc;
}, {} as Record<string, string>);

/**
 * Extract country number from phone number
 * @param phoneNumber - Phone number from backend (format: "919876543210" without + symbol)
 * @returns Country number (e.g., '91', '65', '1') or '91' as default
 */
export const extractCountryCodeFromPhone = (phoneNumber: string): string => {
  if (!phoneNumber) return DEFAULT_COUNTRY_CODE;
  
  const cleanNumber = phoneNumber.replace(/[\s\-\(\)]/g, '');
  
  // Phone numbers from backend are always without + symbol (e.g., "919876543210")
  const sortedCodes = Object.keys(COUNTRY_CODES).sort((a, b) => b.length - a.length);
  
  for (const code of sortedCodes) {
    if (cleanNumber.startsWith(code)) {
      return COUNTRY_CODES[code];
    }
  }
  
  return DEFAULT_COUNTRY_CODE;
};

/**
 * Get country code from subscriber details with proper fallbacks
 * @param subscriberDetails - Subscriber details object
 * @returns Country code (e.g., '91', '65', '1') or default
 */
export const getCountryCodeFromSubscriber = (subscriberDetails: any): string => {
  // Use countryCode from subscriber details (stored during signup)
  if (subscriberDetails?.countryCode) {
    return subscriberDetails.countryCode;
  }
  
  // Fallback: extract from phone number (for existing users)
  if (subscriberDetails?.phoneNumber) {
    return extractCountryCodeFromPhone(subscriberDetails.phoneNumber);
  }
  
  // Final fallback: use default
  return DEFAULT_COUNTRY_CODE;
};
